import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-curvedown",
  "use": "icon-curvedown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-trending-down\" id=\"icon-curvedown\">\n    <polyline points=\"22 17 13.5 8.5 8.5 13.5 2 7\" />\n    <polyline points=\"16 17 22 17 22 11\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol